<template>
  <section class="hero text-center text-light">
    <div class="hero-bg"/>
    <div class="hero-particles-container">
      <canvas id="hero-particles"/>
    </div>
    <div class="container-sm">
      <div class="hero-inner">
        <div class="hero-copy">
          <h1 class="hero-title mt-0">
            For the legal reasons: <br> Our
            <span class="text-primary">Privacy Policy</span>
          </h1>
          <p class="hero-paragraph">
            The privacy policy of <span class="text-primary-branded">Hero Hire</span>, operated by Koffee Studios.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "PolicyHeader"
  }
</script>

<style scoped>

</style>
